import PropTypes from 'prop-types';

export const configurationPropTypes = PropTypes.shape({
  tabs: PropTypes.array.isRequired,
});
